import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PRIMARY_NAV, isActivePath } from '@/lib/navConfig';
import { NavBadge } from './NavBadge';

export const MainNav = ({ badges }) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return (
    <nav className="hidden md:block border-t border-border/60" data-testid="main-nav" aria-label={t('nav.quickNav')}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center gap-1 h-10 overflow-x-auto">
        {PRIMARY_NAV.map((item) => {
          const active = isActivePath(pathname, item.to);
          const Icon = item.icon;
          const count = item.badge ? badges?.[item.badge] || 0 : 0;
          return (
            <Link
              key={item.key}
              to={item.to}
              data-testid={`main-nav-${item.key}`}
              data-active={active ? 'true' : 'false'}
              className={`relative flex items-center gap-1.5 px-3 h-full text-sm whitespace-nowrap transition-colors border-b-2 ${
                active
                  ? 'border-orange-500 text-orange-600 dark:text-orange-400 font-semibold'
                  : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
              }`}
            >
              <Icon className="h-4 w-4" />
              {t(item.labelKey)}
              <NavBadge count={count} tone={item.badge === 'messages' ? 'blue' : 'red'} testId={`main-nav-badge-${item.key}`} />
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
